// extracted by mini-css-extract-plugin
module.exports = {"percent_positive":"columns_percent_positive__1O1Ee","percent_negative":"columns_percent_negative__2ok2O","column_number":"columns_column_number__2GeZ4"};